<template>
  <div class="empty">
    <slot name="icon">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" class="default-icon">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
      </svg>
    </slot>
    <div class="title">{{ title }}</div>
    <div v-if="sub" class="sub">{{ sub }}</div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ title: string; sub?: string }>();
</script>

<style scoped>
.empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
  color: var(--ink-4);
}
.default-icon {
  color: var(--ink-5);
}
.title {
  margin-top: 14px;
  font-weight: 500;
  color: var(--ink);
  font-size: 13.5px;
  max-width: 320px;
}
.sub {
  margin-top: 8px;
  color: var(--ink-4);
  font-size: 12.5px;
  max-width: 360px;
  line-height: 1.6;
}
</style>
